import React, { useState } from 'react';
import axios from 'axios';
// import Page from '../molecules/Page'; // Zakładam, że ścieżka jest poprawna
// Powyższy import został zakomentowany, aby naprawić błąd kompilacji.
// Poniżej znajduje się tymczasowy komponent 'Page'.

// Używamy tej samej zmiennej co w Twoich plikach
const apiUrl = process.env.REACT_APP_API_SOURCE;

// --- TYMCZASOWY KOMPONENT PAGE ---
// UWAGA: Komponent 'Page' jest placeholderem, aby naprawić błąd kompilacji.
// W swoim projekcie proszę USUNĄĆ ten komponent
// i ODKOMENTOWAĆ import wskazujący na Twój prawdziwy komponent 'Page'.
const Page = ({ children, showNav }) => {
  // Prosty placeholder, aby layout działał i przypominał Twój styl
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f9fafb' }}>
      {showNav && (
        <nav style={{ padding: '1rem 2rem', backgroundColor: '#ffffff', borderBottom: '1px solid #e5e7eb', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
          <p style={{ color: '#233855', fontWeight: 'bold', fontSize: '1.25rem' }}>
            Matematly
          </p>
        </nav>
      )}
      <main style={{ flexGrow: 1, width: '100%', maxWidth: '1024px', margin: '0 auto' }}>
        {children}
      </main>
    </div>
  );
};
// --- KONIEC TYMCZASOWEGO KOMPONENTU ---


const RequestDeleteAccount = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    if (!email) {
      setError('Adres e-mail jest wymagany.');
      return;
    }

    setIsLoading(true);

    try {
      // WAŻNE: Musisz utworzyć ten endpoint ('/request-account-deletion/') 
      // na swoim backendzie (DRF), który przyjmie ten email i np.
      // wyśle Ci powiadomienie lub stworzy zadanie "do usunięcia".
      await axios.post(`${apiUrl}request-account-deletion/`, {
        email: email,
        message: message,
      });

      setSuccess(true);
      setEmail('');
      setMessage('');
    } catch (err) {
      setError('Wystąpił błąd podczas wysyłania prośby. Spróbuj ponownie później lub skontaktuj się z nami bezpośrednio.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Page showNav={true}> {/* Zakładam, że tu chcesz pokazać nawigację */}
      <div className="flex flex-col max-w-2xl mx-auto w-full flex-grow px-4 py-8 lg:px-0">
        <div className="bg-white rounded-xl lg:rounded-[3rem] shadow-[4px_4px_12px_rgba(0,0,0,0.35)] border border-gray-200 py-8 px-6 lg:px-14 w-full mt-10">
          
          <h2 className="text-center text-xl font-apotek uppercase tracking-widest font-semibold text-[#233855] mb-6">
            Prośba o usunięcie konta
          </h2>
          
          <p className="text-center text-gray-600 text-sm mb-6">
            Jeśli chcesz usunąć swoje konto i związane z nim dane, wypełnij poniższy formularz. Użyj adresu e-mail powiązanego z Twoim kontem. Zweryfikujemy Twoją prośbę i skontaktujemy się z Tobą, aby potwierdzić usunięcie.
          </p>

          {success ? (
            <div className="text-center p-4 bg-green-100 text-green-800 rounded-lg">
              <p className="font-semibold">Prośba wysłana!</p>
              <p className="text-sm">Otrzymaliśmy Twoją prośbę. Wkrótce się nią zajmiemy.</p>
            </div>
          ) : (
            <form className="space-y-5" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="email" className="block text-[0.8rem] font-apotek uppercase tracking-widest font-semibold text-[#233855] mb-2">
                  Adres email <span className="text-red-600 ml-1">*</span>
                </label>
                <input 
                  type="email" 
                  name="email" 
                  id="email" 
                  autoComplete="email" 
                  required 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  className="ph-no-capture block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-base text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-[#233855] focus:ring-1 focus:ring-[#233855] sm:text-sm/6" 
                  placeholder="twoj@email.com"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-[0.8rem] font-apotek uppercase tracking-widest font-semibold text-[#233855] mb-2">
                  Dodatkowa wiadomość (opcjonalnie)
                </label>
                <textarea 
                  name="message" 
                  id="message" 
                  rows="4"
                  value={message} 
                  onChange={(e) => setMessage(e.target.value)} 
                  className="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-base text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-[#233855] focus:ring-1 focus:ring-[#233855] sm:text-sm/6" 
                  placeholder="Np. powód prośby..."
                />
              </div>

              {error && <p className="text-xs text-center text-red-600 pt-2">{error}</p>}

              <div className="pt-4">
                <button 
                  type="submit" 
                  disabled={isLoading}
                  className="flex w-full justify-center rounded-lg bg-[#8A0000] px-3 py-2 text-sm font-apotek uppercase tracking-widest text-slate-100 shadow-lg hover:bg-[#a10000] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8A0000] disabled:opacity-50"
                >
                  {isLoading ? 'Wysyłanie...' : 'Wyślij prośbę o usunięcie'}
                </button>
              </div>
            </form>
          )}

        </div>
      </div>
    </Page>
  );
};

export default RequestDeleteAccount;